import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { FormTemplateDto } from "../../../models/form/formTemplate";
import {
    getFormTemplate,
    getFormTemplates,
} from "../../../services/formTemplateService";

export interface FormTemplateState {
    templates: FormTemplateDto[] | null;
    currentTemplate: FormTemplateDto | null;
}

const initialState: FormTemplateState = {
    templates: null,
    currentTemplate: null,
};

export const formTemplateSlice = createSlice({
    name: "formTemplate",
    initialState,
    reducers: {
        setTemplates: (state, action: PayloadAction<FormTemplateDto[]>) => {
            state.templates = action.payload;
        },
        setCurrentTemplate: (
            state,
            action: PayloadAction<FormTemplateDto | null>
        ) => {
            state.currentTemplate = action.payload;
        },
    },
});

export const { setTemplates, setCurrentTemplate } = formTemplateSlice.actions;

export const fetchFormTemplates = createAsyncThunk(
    "formTemplate/templates",
    async (_, thunkApi) => {
        const res = await getFormTemplates(thunkApi.signal);
        thunkApi.dispatch(setTemplates(res.data));
    }
);

export const fetchFormTemplate = createAsyncThunk<void, string>(
    "formTemplate/single",
    async (id, thunkApi) => {
        const res = await getFormTemplate(id, thunkApi.signal);
        thunkApi.dispatch(setCurrentTemplate(res.data));
    }
);

export const formTemplateReducer = formTemplateSlice.reducer;
